<template>
  <div ref="observeSection">
    <slot></slot>
  </div>
</template>

<script>
export default {
  data: () => {
    return {
      observer: null,
      initialLoad: false
    }
  },
  mounted() {
    const refOfElement = this.$refs.observeSection;
    this.observer = new IntersectionObserver((entry) =>{
      if(!this.initialLoad && entry && entry.length && entry[0].isIntersecting)
      {
        console.log('Element is in view');
          this.initialLoad = true;
          this.$emit('intersected')
          this.observer.disconnect();
      }
    },
    {
      threshold: 0.2, // proportion of element visible to trigger action
    });
    this.observer.observe(refOfElement)
  },
  beforeDestroy() {
    if (this.observer) {
      this.observer.disconnect(); // Clean up the observer
    }
  }
}
</script>